import ApexCharts from "apexcharts"
import Axios from "axios"

    ; (({ $, $$, log }) => {
        const activeButtonClass = 'server-vote-history__button--active'

        $$('.server-vote-history').forEach(voteHistory => {
            const chartEl = voteHistory.querySelector('.server-vote-history__chart')
            const buttons = voteHistory.querySelectorAll('.server-vote-history__button')
            const url = voteHistory.dataset.url
            const projectId = parseInt(voteHistory.dataset.projectId)

            if (!chartEl || buttons.length === 0 || !url) return

            let chart = null
            let isLoading = false

            const chartOptions = {
                series: [{
                    name: 'votes',
                    type: 'area',
                    data: [0, 0, 0]
                }],
                colors: ['#0071FF'],
                chart: {
                    animations: {
                        enabled: false,
                    },
                    height: 316,
                    // width: '100%',
                    type: 'line',
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false,
                        type: 'x',
                        autoScaleYaxis: false,
                        zoomedArea: {
                            fill: {
                                color: '#90CAF9',
                                opacity: 0.4
                            },
                            stroke: {
                                color: '#0D47A1',
                                opacity: 0.4,
                                width: 1
                            }
                        }
                    }
                },
                grid: {
                    borderColor: '#F0F0F0'
                },
                stroke: {
                    curve: 'smooth',
                    colors: ['#0071FF'],
                    width: 1
                },
                fill: {
                    type: 'gradient',
                    opacity: [.1],
                    colors: ['rgba(56, 97, 251, .4)'],
                    gradient: {
                        shade: 'dark',
                        type: "vertical",
                        shadeIntensity: 0.5,
                        gradientToColors: ['rgba(56, 97, 251, 0.15)'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100],
                        colorStops: []
                    }
                },
                labels: ["", "", ""],
                markers: {
                    colors: '#0071FF',
                    size: 4,
                    shape: "circle",
                    strokeColors: '#fff',
                    strokeWidth: 2,
                    hover: {
                        size: 5,
                        sizeOffset: 0
                    }
                },
                legend: {
                    show: false
                },

            }

            initChart()


            function initChart() {
                chart = new ApexCharts(chartEl, chartOptions)

                buttons.forEach(button => {
                    button.addEventListener('click', async (e) => {
                        e.preventDefault()

                        const type = button.dataset.type


                        const requestResult = await makeRequest(type, projectId)
                        if (requestResult) {
                            buttons.forEach(b => b.classList.remove(activeButtonClass))
                            button.classList.add(activeButtonClass)
                        }
                    })
                })

                setTimeout(() => {
                    chart.render()

                    buttons[0].click()
                }, 0)
            }

            async function makeRequest(type, projectId) {
                if (isLoading) return false
                try {
                    isLoading = true

                    const result = await Axios.get(url, {
                        params: {
                            period: type, id: projectId
                        }
                    })
                    const rawResultArray = result.data.data
                    const labels = []
                    const data = []

                    rawResultArray.forEach(r => {
                        labels.push(r.date)
                        data.push(r.votes)
                    })

                    if (labels.length == 0) {
                        labels.push(...['', '', ''])
                        data.push(...[0, 0, 0])
                    }

                    const opt = {}
                    opt.labels = labels
                    opt.series = [{
                        name: 'votes',
                        data
                    }]

                    chart.updateOptions(opt, false, true)

                    isLoading = false
                    return true
                } catch (e) {
                    isLoading = false
                    return false
                } finally {
                    isLoading = false
                }
                return false
            }
        })
    })(CNS);
